import { useAerialImageAnnotationModal } from '@/composables/annotation/useAerialImageAnnotationModal'
import { useBuildingDetail } from '@/composables/buildingDetails/useBuildingDetails'
import { useZoomBuildingImage } from '@/composables/buildingDetails/useZoomBuildingImage'
import { useOverheadImage } from '@/composables/overheadImage/useOverheadImage'
import { useZoomOverheadImage } from '@/composables/overheadImage/useZoomOverheadImage'
import { useAerialAreasStore } from '@/stores/aerialAreasStore'
import { useAiBuildingStore } from '@/stores/aiBuildingStore'
import { useAnnotationImageStore } from '@/stores/annotationImageStore'
import { useCommonModalStore } from '@/stores/commonModalStore'
import { useDisasterStore } from '@/stores/disasterStore'
import { useEmergencyInspectionResultStore } from '@/stores/emergencyInspectionResultStore'
import { useGeoserverStatusStore } from '@/stores/geoserverStatusStore'
import { useGovernmentSettingStore } from '@/stores/governmentSettingStore'
import { useMapPointCloudSettingsStore } from '@/stores/mapPointCloudSettingsStore'
import { useMapPointCloudStore } from '@/stores/mapPointCloudStore'
import { useMapViewSettingsStore } from '@/stores/mapViewSettingsStore'
import { useMiiaFwStore } from '@/stores/miiaFwStore'
import { useOverheadImageStore } from '@/stores/overheadImageUrlsStore'
import { useRecertificationDialogStore } from '@/stores/recertificationDialogStore'
import { useRefreshStore } from '@/stores/refreshStore'

export const useStoreUtils = () => {
  const aerialAreasStore = useAerialAreasStore()
  const aiBuilding = useAiBuildingStore()
  const annotationImageStore = useAnnotationImageStore()
  const commonModalStore = useCommonModalStore()
  const disasterStore = useDisasterStore()
  const emergencyInspectionResult = useEmergencyInspectionResultStore()
  const geoserverStatusStore = useGeoserverStatusStore()
  const governmentSetting = useGovernmentSettingStore()
  const mapPointCloudSettingsStore = useMapPointCloudSettingsStore()
  const mapPointCloudStore = useMapPointCloudStore()
  const mapViewSettingsStore = useMapViewSettingsStore()
  const miiaFwStore = useMiiaFwStore()
  const overheadImageStore = useOverheadImageStore()
  const refreshStore = useRefreshStore()

  const aerialImageAnnotationModal = useAerialImageAnnotationModal()
  const buildingDetail = useBuildingDetail()
  const zoomBuildingImage = useZoomBuildingImage()
  const recertificationDialogStore = useRecertificationDialogStore()
  const overheadImage = useOverheadImage()
  const zoomOverheadImage = useZoomOverheadImage()

  const allReset = () => {
    aerialAreasStore.reset()
    aiBuilding.reset()
    annotationImageStore.reset()
    commonModalStore.reset()
    disasterStore.reset()
    emergencyInspectionResult.reset()
    geoserverStatusStore.reset()
    governmentSetting.reset()
    mapPointCloudSettingsStore.reset()
    mapPointCloudStore.reset()
    mapViewSettingsStore.reset()
    miiaFwStore.reset()
    overheadImageStore.reset()
    refreshStore.reset()

    aerialImageAnnotationModal.reset()
    buildingDetail.reset()
    zoomBuildingImage.reset()
    recertificationDialogStore.reset()
    overheadImage.reset()
    zoomOverheadImage.reset()
  }

  const resetForSignin = () => {
    mapPointCloudSettingsStore.reset()
  }

  return {
    allReset,
    resetForSignin
  }
}
